<template>
  <v-container>
    <v-card class="elevation-12">
      <v-toolbar
        color="orange darken-3"
        dark
        flat
      >
        <v-toolbar-title>Login</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-form>
          <v-text-field
            label="Username"
            name="login"
            prepend-icon="mdi-account"
            type="text"
            v-model="username"
          ></v-text-field>

          <v-text-field
            label="Password"
            name="password"
            prepend-icon="mdi-lock"
            type="password"
            v-model="password"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="white--text"
          color="orange darken-3"
          @click="login"
        >
          Login
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { getStorage } from './../_helpers'
export default {
  name: 'AppLoginForm',
  props: ['user'],
  data: () => ({
    username: '',
    password: ''
  }),
  methods: {
    login () {
      this.$store.dispatch('login', { username: this.username, password: this.password })
        .then(() => {
          let { permission } = getStorage('_admin')
          if (permission.includes('Request'))
            this.$router.push({ name: 'request-helper-maid-list' })
          else if (permission.includes('Supporter'))
            this.$router.push({ name: 'supporter-list' })
          else if (permission.includes('Banner'))
            this.$router.push({ name: 'banner-list' })
          else if (permission.includes('User'))
            this.$router.push({ name: 'user-list' })
          else
            this.$router.push({ name: 'supporter-list' })
        })
        .catch(err => alert(err.response.data.message))
    },
    validate () {
      if (!this.username) {
        alert('Please fill in username.')
        return false
      }
      if (!this.password) {
        alert('Please fill in password.')
        return false
      }
      return true
    }
  }
}
</script>